import type { ComponentProps } from "react";
import { AutoResizeTextarea } from "@/components/ui";
import { cn } from "@/lib/cn";

/**
 * Where an open cell shows: over the cell itself, as wide as its column, at
 * the cell's own padding, alignment and the grid's type size. The editor and
 * the full-text preview both open here, so reading and editing a long value
 * look the same.
 */
export const CELL_OVERLAY =
  "absolute inset-x-0 top-0 px-[inherit] text-appkit-body [font-variant-numeric:inherit] [text-align:inherit]";

/**
 * A cell's whole text in the open-cell box: one row tall like the cell, the
 * text wrapping and the box growing down past the row, then scrolling.
 */
export function DatasetCellBox({
  className,
  ...props
}: ComponentProps<typeof AutoResizeTextarea>) {
  return (
    <AutoResizeTextarea
      rows={1}
      {...props}
      className={cn(CELL_OVERLAY, "min-h-9 py-2", className)}
    />
  );
}
